import Button from '../../../components/ui/Button';

/**
 * Finish flow for standalone /repairs session: confirm the work is saved,
 * then return to the dashboard. Certificates are created from Reports.
 */
export default function RepairSessionFinishModal({
  repairedCount,
  onClose,
  onComplete,
  isFinishing,
}) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal session-summary-modal repair-finish-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Finish repair session</h2>
        <p className="modal-subtitle">
          {repairedCount} repair{repairedCount === 1 ? '' : 's'} saved. When the job is finished, create the certificate from{' '}
          <strong>Reports → Generate report</strong>.
        </p>
        <div className="modal-actions">
          <Button type="button" variant="secondary" onClick={onClose} disabled={isFinishing}>
            Back to session
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={() => onComplete()}
            disabled={isFinishing}
          >
            {isFinishing ? 'Finishing…' : 'Return to dashboard'}
          </Button>
        </div>
      </div>
    </div>
  );
}
